import { motion } from "framer-motion";
import { Layers, MapPinned, HardHat, Calculator, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    icon: Layers,
    num: "01",
    title: "Levantamento Planialtimétrico",
    desc: "Mapeamento detalhado do relevo e perímetros para projetos de engenharia.",
  },
  {
    icon: MapPinned,
    num: "02",
    title: "Georreferenciamento",
    desc: "Certificação de imóveis rurais conforme as normas do INCRA.",
  },
  {
    icon: HardHat,
    num: "03",
    title: "Acompanhamento de Obra",
    desc: "Locação de pilares, terraplenagem e controle dimensional rigoroso.",
  },
  {
    icon: Calculator,
    num: "04",
    title: "Cálculos Volumétricos",
    desc: "Medição precisa de volumes de corte e aterro para controle de custos e estoque.",
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 36 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.1, duration: 0.75, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Services() {
  return (
    <section id="servicos" className="relative py-24 lg:py-32 carto-grid">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <motion.p
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.6 }}
              transition={{ duration: 0.6 }}
              className="font-mono text-xs uppercase tracking-[0.32em] text-dm-contour"
            >
              Especialidades
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.6 }}
              transition={{ delay: 0.1, duration: 0.7 }}
              className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white"
            >
              Serviços de <span className="text-gradient">Alta Precisão</span>
            </motion.h2>
          </div>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.25, duration: 0.7 }}
            className="max-w-sm text-sm leading-relaxed text-slate-400"
          >
            Do terreno ao dado confiável: tecnologia RTK, estações totais e
            drones com equipe técnica qualificada.
          </motion.p>
        </div>

        <div className="mt-14 grid gap-5 md:grid-cols-2">
          {SERVICES.map((s, i) => (
            <motion.article
              key={s.num}
              data-testid={`service-card-${i + 1}`}
              variants={cardVariants}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.25 }}
              className="group relative h-full rounded-2xl glass p-8 lg:p-10 transition-all duration-500 hover:border-dm-glow/40 hover:bg-card/80 hover:-translate-y-1.5 overflow-hidden"
            >
              <div className="absolute -right-4 -top-4 font-display text-[92px] font-extrabold leading-none text-white/[0.045] select-none transition-colors duration-500 group-hover:text-dm-glow/[0.08]">
                {s.num}
              </div>
              <div className="flex items-start justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-dm-blue/25 to-dm-glow/10 border border-dm-glow/25 text-dm-glow transition-transform duration-500 group-hover:scale-110">
                  <s.icon size={22} />
                </span>
                <ArrowUpRight
                  size={20}
                  className="text-slate-600 transition-all duration-500 group-hover:text-dm-glow group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </div>
              <h3 className="mt-7 font-display text-xl lg:text-2xl font-semibold text-white">
                {s.title}
              </h3>
              <p className="mt-3 max-w-md text-sm lg:text-base leading-relaxed text-slate-400">
                {s.desc}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
